import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BarChartIcon from '@mui/icons-material/BarChart';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { useTheme } from '../context/ThemeContext';
import useWindowSize from '../hooks/useWindowSize';

function Navbar() {
  const [search, setSearch] = useState('');
  const [sidebar, setSidebar] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const { theme, toggleTheme, colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  useEffect(() => {
    const stored = localStorage.getItem('user');
    if (stored) setUser(JSON.parse(stored));
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) { navigate(`/?search=${search}`); setShowSearch(false); }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setSidebar(false);
    navigate('/');
  };

  const isLight = theme === 'light';

  const menuItems = [
    { label: 'Mis entradas', path: '/my-tickets' },
    { label: 'Mi perfil', path: '/profile' },
    { label: 'Vende con nosotros', path: '/vende-tus-entradas' },
    { label: 'Ayuda y contacto', path: '/contact' },
    { label: 'Política de privacidad', path: '/privacy' },
    { label: 'Autorización menores', path: '/autorizacion-menores.pdf' },
  ];

  const handleMenuClick = (item) => {
    if (item.path.endsWith('.pdf')) {
      window.open(item.path, '_blank');
    } else {
      navigate(item.path);
    }
    setSidebar(false);
  };

  return (
    <>
      <nav style={{ backgroundColor: colors.navBg, position: 'sticky', top: 0, zIndex: 1000 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: isMobile ? '0.6rem 1rem' : '0.6rem 2rem', gap: '1rem' }}>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexShrink: 0 }}>
            <MenuIcon style={{ color: '#ffffff', cursor: 'pointer' }} onClick={() => setSidebar(true)} />
            <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <img src="/logo.png" alt="GaliTicket" style={{ height: isMobile ? '34px' : '42px', width: 'auto', objectFit: 'contain', filter: isLight ? 'brightness(0) invert(1)' : 'none' }} />
              <img src="/logo-text.png" alt="GaliTicket" style={{ height: isMobile ? '22px' : '28px', width: 'auto', objectFit: 'contain', filter: isLight ? 'brightness(0) invert(1)' : 'none' }} />
            </Link>
          </div>

          {!isMobile && (
            <form onSubmit={handleSearch} style={{ display: 'flex', alignItems: 'center', backgroundColor: colors.searchBg, borderRadius: '25px', padding: '0.5rem 1rem', flex: 1, maxWidth: '600px', gap: '0.5rem', border: `1px solid ${isLight ? 'rgba(255,255,255,0.3)' : colors.border}` }}>
              <SearchIcon style={{ color: isLight ? 'rgba(255,255,255,0.8)' : colors.accent, flexShrink: 0 }} />
              <input style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: isLight ? '#ffffff' : colors.text, fontSize: '0.95rem' }} type="text" placeholder="Busca artistas, eventos o recintos..." value={search} onChange={(e) => setSearch(e.target.value)} />
              <button type="submit" style={{ backgroundColor: isLight ? '#ffffff' : colors.accent, color: isLight ? colors.accent : colors.accentText, border: 'none', padding: '0.4rem 1.2rem', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem', flexShrink: 0 }}>
                Buscar
              </button>
            </form>
          )}

          <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '0.8rem' : '1.5rem', flexShrink: 0 }}>
            {isMobile && (
              <SearchIcon style={{ color: '#ffffff', cursor: 'pointer', fontSize: 24 }} onClick={() => setShowSearch(!showSearch)} />
            )}
            <div onClick={toggleTheme} style={{ color: '#ffffff', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
              {theme === 'dark' ? <LightModeIcon style={{ fontSize: 22 }} /> : <DarkModeIcon style={{ fontSize: 22 }} />}
            </div>
            {user ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }} onClick={() => navigate('/profile')}>
                <AccountCircleIcon style={{ fontSize: 20, color: '#ffffff' }} />
                {!isMobile && <span style={{ color: '#ffffff', fontSize: '0.9rem', fontWeight: 'bold' }}>{user.name}</span>}
              </div>
            ) : (
              <div onClick={() => navigate('/login')} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', backgroundColor: '#ffffff', color: colors.accent, padding: '0.4rem 1rem', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem', whiteSpace: 'nowrap' }}>
                <AccountCircleIcon style={{ fontSize: 20 }} />
                {!isMobile && <span>Acceder</span>}
              </div>
            )}
          </div>
        </div>

        {isMobile && showSearch && (
          <div style={{ padding: '0 1rem 0.8rem' }}>
            <form onSubmit={handleSearch} style={{ display: 'flex', alignItems: 'center', backgroundColor: colors.searchBg, borderRadius: '25px', padding: '0.5rem 1rem', gap: '0.5rem', border: `1px solid ${isLight ? 'rgba(255,255,255,0.3)' : colors.border}` }}>
              <SearchIcon style={{ color: 'rgba(255,255,255,0.8)', flexShrink: 0 }} />
              <input style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: '#ffffff', fontSize: '0.95rem' }} type="text" placeholder="Busca eventos..." value={search} onChange={(e) => setSearch(e.target.value)} autoFocus />
              <button type="submit" style={{ backgroundColor: '#ffffff', color: colors.accent, border: 'none', padding: '0.4rem 1rem', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.85rem' }}>
                Buscar
              </button>
            </form>
          </div>
        )}
      </nav>

      {sidebar && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 2000 }} onClick={() => setSidebar(false)}>
          <div style={{ position: 'absolute', top: 0, left: 0, width: isMobile ? '85%' : '280px', maxWidth: '320px', height: '100%', backgroundColor: colors.bgSecondary, borderRight: `1px solid ${colors.border}`, padding: '1.5rem 0', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1.5rem 1.5rem', borderBottom: `1px solid ${colors.border}` }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                <img src="/logo.png" alt="GaliTicket" style={{ height: '32px', width: 'auto', objectFit: 'contain' }} />
                <img src="/logo-text.png" alt="GaliTicket" style={{ height: '20px', width: 'auto', objectFit: 'contain' }} />
              </div>
              <CloseIcon style={{ color: colors.textSecondary, cursor: 'pointer' }} onClick={() => setSidebar(false)} />
            </div>

            {user && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1.5rem', borderBottom: `1px solid ${colors.border}` }}>
                <AccountCircleIcon style={{ color: colors.accent, fontSize: 40 }} />
                <div>
                  <p style={{ color: colors.text, fontWeight: 'bold', fontSize: '0.95rem', margin: 0 }}>{user.name}</p>
                  <p style={{ color: colors.textSecondary, fontSize: '0.8rem', margin: 0 }}>{user.email}</p>
                </div>
              </div>
            )}

            {menuItems.map(item => (
              <div key={item.label} style={{ padding: '1rem 1.5rem', color: colors.text, cursor: 'pointer', fontSize: '0.95rem', borderBottom: `1px solid ${colors.border}` }} onClick={() => handleMenuClick(item)}>
                {item.label}
              </div>
            ))}


            {/* Escanear entradas — admin y portero */}
            {(user?.role === 'admin' || user?.role === 'portero') && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '1rem 1.5rem', color: colors.accent, cursor: 'pointer', fontSize: '0.95rem', borderBottom: `1px solid ${colors.border}`, fontWeight: 'bold' }}
                onClick={() => { navigate('/escanear'); setSidebar(false); }}>
                <QrCodeScannerIcon style={{ fontSize: 18 }} /> Escanear entradas
              </div>
            )}

            {user?.role === 'admin' && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '1rem 1.5rem', color: colors.accent, cursor: 'pointer', fontSize: '0.95rem', borderBottom: `1px solid ${colors.border}`, fontWeight: 'bold' }} onClick={() => { navigate('/admin'); setSidebar(false); }}>
                <DashboardIcon style={{ fontSize: 18 }} /> Panel de administrador
              </div>
            )}

            {(user?.role === 'admin' || user?.role === 'promotor') && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '1rem 1.5rem', color: colors.accent, cursor: 'pointer', fontSize: '0.95rem', borderBottom: `1px solid ${colors.border}`, fontWeight: 'bold' }}
                onClick={() => { navigate('/promotor'); setSidebar(false); }}>
                <BarChartIcon style={{ fontSize: 18 }} /> {user?.role === 'admin' ? 'Reportes globales' : 'Mis reportes'}
              </div>
            )}

            {user ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '1rem 1.5rem', color: '#ff4444', cursor: 'pointer', fontSize: '0.95rem', marginTop: '0.5rem' }} onClick={handleLogout}>
                <LogoutIcon style={{ fontSize: 18 }} /> Cerrar sesión
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '1rem 1.5rem', color: colors.accent, cursor: 'pointer', fontSize: '0.95rem', fontWeight: 'bold' }} onClick={() => { navigate('/login'); setSidebar(false); }}>
                <AccountCircleIcon style={{ fontSize: 18 }} /> Iniciar sesión
              </div>
            )}

            {/* Redes sociales */}
            <div style={{ padding: '1.5rem', borderTop: `1px solid ${colors.border}`, marginTop: '0.5rem' }}>
              <p style={{ color: colors.textSecondary, fontSize: '0.75rem', marginBottom: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Síguenos</p>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <a href="https://www.facebook.com/GaliTicket" target="_blank" rel="noopener noreferrer" style={{ color: colors.textSecondary, textDecoration: 'none', fontSize: '0.85rem' }}>Facebook</a>
                <a href="https://www.instagram.com/gali_ticket" target="_blank" rel="noopener noreferrer" style={{ color: colors.textSecondary, textDecoration: 'none', fontSize: '0.85rem' }}>Instagram</a>
                <a href="https://www.tiktok.com/@galiticket" target="_blank" rel="noopener noreferrer" style={{ color: colors.textSecondary, textDecoration: 'none', fontSize: '0.85rem' }}>TikTok</a>
              </div>
            </div>

          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;